import { render } from "./Button.vue?vue&type=template&id=3fae48c8"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Button.vue?vue&type=style&index=0&id=3fae48c8&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script